// extracted by mini-css-extract-plugin
export var modalFooter = "_ni-0";